// extracted by mini-css-extract-plugin
module.exports = {"root":"DescriptionSection_root__m7oUk","rootOnCmsPages":"DescriptionSection_rootOnCmsPages__BGu5C","titleWrapper":"DescriptionSection_titleWrapper__N_bLQ"};